import * as React from 'react'
import { cn } from '@/lib/utils'

export type PageHeaderLevel = 'h1' | 'h2' | 'h3'

export interface PageHeaderProps {
  title?: React.ReactNode
  titleAs?: PageHeaderLevel
  description?: React.ReactNode
  actions?: React.ReactNode
  children?: React.ReactNode
  className?: string
}

export function PageHeader({
  title,
  titleAs = 'h1',
  description,
  actions,
  children,
  className,
}: PageHeaderProps): React.JSX.Element {
  const Tag = titleAs
  return (
    <header className={cn('rounded-lg border border-primary/30 bg-card p-4 sm:p-5', className)}>
      <div className="flex flex-col gap-2">
        {title || actions ? (
          <div className="flex items-start justify-between gap-4">
            {title ? <Tag className="text-lg font-black tracking-tight sm:text-xl md:text-2xl">{title}</Tag> : null}
            {actions ? <div className="flex shrink-0 flex-wrap items-center gap-2">{actions}</div> : null}
          </div>
        ) : null}
        {description ? <p className="text-xs text-muted-foreground sm:text-sm">{description}</p> : null}
        {children}
      </div>
    </header>
  )
}
